import script from "./xt_headline.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_headline.vue?vue&type=script&setup=true&lang=js"

import "./xt_headline.vue?vue&type=style&index=0&id=32844547&lang=scss"
import "./xt_headline.vue?vue&type=style&index=1&id=32844547&scoped=true&lang=scss"
import "./xt_headline.vue?vue&type=style&index=2&id=32844547&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32844547"]])

export default __exports__